import type { PropType, VNode } from 'vue'
import { defineComponent, Fragment } from 'vue'

export const VNodeRenderer = defineComponent({
    props: {
        vNode: Object as PropType<VNode>
    },
    setup(props) {
       return () => props.vNode;
    }
});

export function flattenVNodeTree(nodes: VNode[]): VNode[] {
    const flattened: VNode[] = [];

    nodes.forEach((node) => {
        if (node.type === Fragment && Array.isArray(node.children)) {
            flattened.push(...node.children as VNode[]);
        } else {
            flattened.push(node);
        }
    });


    return flattened;
}